export const MESSAGE_TYPE = {
  CMD: 'cmd',
};

export const CMD_CODE = {
  RENDER: 'render',
  EXEC: 'exec',
};

export const SEND_ORIGIN = {
  INPUT: 'input',
  QUICK_BUTTON: 'quickButton',
};
